import { render, staticRenderFns } from "./LibraryArchiveEvidence.vue?vue&type=template&id=10f97023&"
import script from "./LibraryArchiveEvidence.vue?vue&type=script&lang=ts&"
export * from "./LibraryArchiveEvidence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports